import React from 'react';

export const NavButton = ({ active, onClick, label, light = true }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 rounded-full text-sm font-bold transition-all ${active ? "bg-cyan-400 text-blue-900 shadow-lg" : light ? "text-blue-50 hover:text-white hover:bg-white/10" : "text-gray-500 hover:text-blue-600 hover:bg-blue-50"}`}
  >
    {label}
  </button>
);

export const MobileNavButton = ({ active, onClick, label }) => (
  <button
    onClick={onClick}
    className={`text-left p-4 rounded-xl font-bold transition-all ${active ? "bg-cyan-400 text-blue-900 shadow-xl" : "text-white hover:bg-white/5"}`}
  >
    {label}
  </button>
);
